import { Route, Routes } from "react-router-dom";
import { ContactModal } from "@/components/ContactModal";
import { PhoneLayout } from "@/components/PhoneLayout";
import { GuidePage } from "@/pages/GuidePage";
import { HomePage } from "@/pages/HomePage";
import { IdentityPage } from "@/pages/IdentityPage";
import { SchoolsPage } from "@/pages/SchoolsPage";
import { ServicePage } from "@/pages/ServicePage";

export default function App() {
  return (
    <PhoneLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/schools" element={<SchoolsPage />} />
        <Route path="/identity" element={<IdentityPage />} />
        <Route path="/guide" element={<GuidePage />} />
        <Route path="/service" element={<ServicePage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      <ContactModal />
    </PhoneLayout>
  );
}
